import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext.js';
import styles from './Login.module.css';

export function Login() {
  const { login } = useAuth();
  const [value, setValue] = useState('');

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (value.length === 0) return;
    login(value);
  };

  return (
    <main className={styles.container}>
      <form className={styles.card} onSubmit={onSubmit}>
        <h1 className={styles.title}>Camp Betz Water</h1>
        <p className={styles.muted}>Enter the password to view the dashboard.</p>
        <label className={styles.label}>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={styles.input}
            autoFocus
          />
        </label>
        <button type="submit" className={styles.submit} disabled={value.length === 0}>
          Sign in
        </button>
      </form>
    </main>
  );
}
